import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { useState } from "@/hooks/mapGet/index.js";
export default defineComponent({
  name: "musicList",
  props: {
    musicList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    itemHeight: {
      type: String,
      default: function _default() {
        return "60px";
      }
    }
  },
  setup: function setup(props) {
    var state = useState("player", ["currentId"]);
    var store = useStore();
    var isActive = ref(-1);
    /* 点击最新音乐添加背景色 */

    var newMscItemClick = function newMscItemClick(item, id) {
      isActive.value = +id; //播放音乐,电台不播

      if (item.type) {
        store.dispatch("player/setCurrentSong", id);
      }
    };
    /* 获取每个歌的歌手 */


    var newMusicSonger = computed(function () {
      return props.musicList.map(function (item) {
        var _item$song;

        return (_item$song = item.song) === null || _item$song === void 0 ? void 0 : _item$song.artists.map(function (item) {
          return item.name;
        }).join("/");
      });
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      isActive: isActive,
      newMscItemClick: newMscItemClick,
      newMusicSonger: newMusicSonger
    });
  },
  components: {}
});